import { LitElement, html } from 'lit';
import { style } from './error-message.style.js';
import { DebugService } from '../services/debug.service.js';
import { REFI_ESIGN_CONST } from '../../../constants/app.constants.js';

class RefiErrorMessage extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('ErrorMessageComponent');
    this.message = '';
  }

  static get properties() {
    return {
      message: { attribute: true },
    };
  }

  static get styles() {
    return style;
  }

  render() {
    return html`
      <div class="error-message-container">
        <img src="${REFI_ESIGN_CONST.ASSETS_URL}/caution.svg" alt="Caution" />
        <p>${this.message}</p>
      </div>
    `;
  }
}

customElements.define('refi-error-message', RefiErrorMessage);
